import { createFeature, createReducer, on } from '@ngrx/store';
import { AddOrganizationActions } from '../../actions/add-organization/add-organization.actions';
import { OrganizationAdminActions } from '../../actions/organization-admin/organization-admin.actions';
import { IDropdown } from '@models/dropdown.model';

export const addOrganizationFeatureKey = 'addOrganization';

export interface State {
  name: string,
  typeSearch: string
  type: number | null,
  organizationID: string,
  legacyOrganizationID: string,
  crmID: string,
  address: string,
  addressB: string,         
  zipCode: string,            
  city: string,
  stateSearch: string,
  state: number | null,
  isValid: boolean,
  isTestOrganization: number,
  statesDropdown: IDropdown[],
  citiesDropdown: IDropdown[],
  organizationTypesDropdown: IDropdown[],
}

export const initialState: State = {
  name: "",
  typeSearch: "",
  type: null,
  organizationID: "",
  legacyOrganizationID: "",
  crmID: "",
  address: "",
  addressB: "",
  zipCode: "",
  city: "",
  stateSearch: "",
  state: null,
  isValid: false,
  isTestOrganization: 0,

  statesDropdown: [],
  citiesDropdown: [],
  organizationTypesDropdown: [],
};

export const reducer = createReducer(
  initialState,

  on(AddOrganizationActions.getOrganizationDetailsSuccess, (state, action) => ({
    ...state,
    name: action.details.name,
    type: action.details.organizationTypeID,
    organizationID: action.details.id,
    legacyOrganizationID: action.details.legacyOrganizationID,
    crmID: action.details.crmid,
    address: action.details.addressLine1,
    addressB: action.details.addressLine2,
    zipCode: action.details.postalCode,
    city: action.details.city,
    state: action.details.stateID,
    isTestOrganization: action.details.isTestOrganization ?? 0,
  })),

  on(OrganizationAdminActions.setTestOrganizationStatusSuccess, (state, { isTestOrganization }) => ({
    ...state,
    isTestOrganization,
  })),


  on(AddOrganizationActions.nameChanged, (state, action) => ({
    ...state,
    name: action.value
  })),
  on(AddOrganizationActions.typeSearchChanged, (state, action) => ({
    ...state,
    typeSearch: action.value
  })),
  on(AddOrganizationActions.typeChanged, (state, action) => ({
    ...state,
    type: action.value
  })),
  on(AddOrganizationActions.legacyIDChanged, (state, action) => ({
    ...state,
    legacyOrganizationID: action.value
  })),  on(AddOrganizationActions.cRMIDChanged, (state, action) => ({
    ...state,
    crmID: action.value
  })),
  on(AddOrganizationActions.organizationIDChanged, (state, action) => ({
    ...state,
    organizationID: action.value
  })),
  on(AddOrganizationActions.addressChanged, (state, action) => ({
    ...state,
    address: action.value
  })),
  on(AddOrganizationActions.addressBChanged, (state, action) => ({
    ...state,
    addressB: action.value
  })),
  on(AddOrganizationActions.zipCodeChanged, (state, action) => ({
    ...state,
    zipCode: action.value
  })),
  on(AddOrganizationActions.cityChanged, (state, action) => ({
    ...state,
    city: action.value
  })),
  on(AddOrganizationActions.stateSearchChanged, (state, action) => ({
    ...state,
    stateSearch: action.value
  })),
  on(AddOrganizationActions.stateChanged, (state, action) => ({
    ...state,
    state: action.value,
    stateSearch: ""
  })),

  on(AddOrganizationActions.validityChanged, (state, action) => ( {
    ...state,
    isValid: action.validity
  })),
  on(AddOrganizationActions.getStatesSuccess, (state, action) => ({
    ...state,
    statesDropdown: action.contents
  })),
  on(AddOrganizationActions.getCitiesSuccess, (state, action) => ({
    ...state,
    citiesDropdown: action.contents
  })),
  on(AddOrganizationActions.getOrganizationTypesSuccess, (state, action) => ({
    ...state,
    organizationTypesDropdown: action.contents
  })),
);

export const addOrganizationFeature = createFeature({
  name: addOrganizationFeatureKey,
  reducer,
});

